import React, { Component } from 'react'
import PropTypes from 'prop-types'

class TutorialStep extends Component {
    getContent(props) {
        if (props.img) {
            return (<img className='responsive-img' src={ props.img }/>)
        }
        return props.children
    }

    render() {
        const bg = { background: this.props.background }
        return (
            <div style={ bg }>
                { this.getContent(this.props) }
            </div>
        )
    }
}

TutorialStep.propTypes = {
    img: PropTypes.string.required,
    children: PropTypes.element,
    background: PropTypes.string
}

export default TutorialStep



// WEBPACK FOOTER //
// ./src/home/components/TutorialStep.js